// Cap a displayed filename/path length; keep the extension and drop the middle
// so long CAM names don't blow out the layout. Pair with a full-name tooltip.
export const MAX_FILENAME_LEN = 45;

export function truncateFilename(name: string, max = MAX_FILENAME_LEN): string {
  if (name.length <= max) return name;
  const dot = name.lastIndexOf('.');
  const ext = dot > 0 ? name.slice(dot) : '';
  const head = name.slice(0, Math.max(0, max - ext.length - 1));
  return `${head}…${ext}`;
}
